import {
  UNVERIFIED_ADMIN,
  UNVERIFIED_PURCHASER,
  UNVERIFIED_DIY,
  VERIFIED_ADMIN,
  VERIFIED_PURCHASER,
  VERIFIED_USER,
} from '../constants/constants';

export const getSvocId = () => {
  if (window !== 'undefined' && window?.THDCustomer) {
    return typeof window !== 'undefined' && window?.THDCustomer?.default?.svocID;
  }
  if (window !== 'undefined' && window?.THD_USER_SESSION) {
    return typeof window !== 'undefined' && window?.THD_USER_SESSION?.default?.svocID;
  }
  return null; // '041FBEB7EE53EAF20S';
};

export const getUserId = () => {
  if (window !== 'undefined' && window?.THDCustomer) {
    return typeof window !== 'undefined' && window?.THDCustomer?.default?.userID;
  }
  if (window !== 'undefined' && window?.THD_USER_SESSION) {
    return typeof window !== 'undefined' && window?.THD_USER_SESSION?.default?.userID;
  }
  return null; // '041FBEB7EE69EAF20U';
};

export const isB2BUser = () => {
  return typeof window !== 'undefined' && window?.THDCustomer?.default?.isB2BCustomer;
};

export const getHost = () => {
  return window.location.hostname;
};

export const isB2Badmin = () => {
  return typeof window !== 'undefined' && window?.THDCustomer?.default?.role === 'ADMIN';
};

export const userRole = () => {
  if (window?.THDCustomer?.default?.role === 'ADMIN') {
    return 'Admin';
  }
  if (window?.THDCustomer?.default?.role === 'PURCHASER') {
    return 'Purchaser';
  }
  return null;
};

export const getUserEmail = () => {
  return typeof window !== 'undefined' && window?.THDCustomer?.default?.email;
};

export const defineUserType = (isB2B, isAdmin, isEnrolled) => {
  if (isB2B && !isAdmin && !isEnrolled) {
    return UNVERIFIED_PURCHASER;
  }
  if (isB2B && isAdmin && !isEnrolled) {
    return UNVERIFIED_ADMIN;
  }
  if (!isB2B && !isEnrolled) {
    return UNVERIFIED_DIY;
  }
  if (isB2B && isEnrolled && !isAdmin) {
    return VERIFIED_PURCHASER;
  }
  if (isB2B && isEnrolled && isAdmin) {
    return VERIFIED_ADMIN;
  }
  if (!isB2B && isEnrolled) {
    return VERIFIED_USER;
  }
  return UNVERIFIED_DIY;
};

export const getAuthorizationToken = () => {
  if (window !== 'undefined' && window?.THDCustomer) {
    return typeof window !== 'undefined' && window?.THDCustomer?.default?.jwt;
  }
  if (window !== 'undefined' && window?.THD_USER_SESSION && window?.THD_USER) {
    return typeof window !== 'undefined' && window?.THD_USER_SESSION?.default?.jwt;
  }
  return null;
};

export const redirectToLearnMore = () => {
  window.location.href = 'http://www.homedepot.com/c/military/';
};
